import { AuthedRoute } from "../../helpers/authed-route";
import { KintoneExportR } from "./kintone-export/routes";

export const DataTransferR = {
  ...KintoneExportR,
};

export const DataTransferRoute = () => {
  return (
    <>
      {Object.entries(DataTransferR).map(([k, r]) => {
        return (
          <AuthedRoute
            exact
            path={r.forRouter.path}
            component={r.forRouter.component}
            key={`DataTransferRoute-${k}`}
          />
        );
      })}
    </>
  );
};
